import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgSpeaker = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill,
    fillSecondary
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.9984 5.05471L14 18.9459C14 20.0909 12.5763 20.7393 11.6006 20.0521L6.0281 16.0464H3.30297C2.61176 16.0464 2.00159 15.5127 2.00159 14.8254L2 9.17675C2 8.52826 2.56885 7.9558 3.30138 7.9558H6.02651L11.599 3.94856C12.5747 3.2613 13.9984 3.9098 13.9984 5.05471ZM19.0713 5.44881C20.8783 6.99087 21.9992 9.38067 21.9992 12.0026C22.0345 14.659 20.8783 17.0112 19.0713 18.5532C18.6732 18.8993 18.0592 18.8225 17.7345 18.3993C17.4098 17.9747 17.4451 17.3196 17.8432 16.9733C19.2168 15.8167 20.0835 14.0051 20.0835 12.0009C20.0835 9.99651 19.2168 8.22253 17.8432 7.02851C17.4451 6.68215 17.3731 6.02555 17.7345 5.60241C18.0592 5.17773 18.6747 5.10094 19.0713 5.44881ZM16.7108 8.37626C17.688 9.21556 18.2808 10.5141 18.2808 12.0019C18.2808 13.4882 17.6525 14.7867 16.6754 15.626C16.2911 15.9688 15.6983 15.8928 15.3849 15.4739L15.3153 15.3979C15.0019 15.0162 15.0714 14.405 15.4544 14.1009C16.0472 13.6432 16.396 12.8799 16.396 12.0019C16.396 11.1998 16.0472 10.4753 15.5239 9.97886C15.1055 9.59722 15.036 8.98598 15.3848 8.52832C15.6983 8.1079 16.2925 8.03188 16.7108 8.37626Z", fill: props.fill }));
});
export default SvgSpeaker;
